import { Layout } from 'antd';
import React from 'react'
import { Outlet } from 'react-router-dom';
import LogBookNavbar from '../../components/layout/navbar/LogBookNavbar';
import LogBookSidebar from '../../components/layout/sidebar/LogBookSidebar';


const { Content } = Layout; 

const LogBookOutlet = () => {
    return (
        <div>
          <Layout>
            <LogBookNavbar />
            <Layout>
              <LogBookSidebar />
              <Content className="bg-[#EAF5FF]">
                <Outlet /> 
              </Content>
            </Layout>
          </Layout>
        </div>
      );
}

export default LogBookOutlet
